import Vue from  'vue'
import Router from 'vue-router'
import { common } from './common'
import { route } from './router'
import { timeLimited } from './timeLimited'
import { introduction } from './introduction'
import { rule } from './rule'
import devSend from "@/track/index";


Vue.use(Router)

//common 文件下大部分为服务协议页面
//router 文件为常规路由
//timeLimited 文件为限时活动页面路由
//introduction 文件为介绍说明页面路由
//rule 文件为规则页面路由

let newRoute = route.concat(common,timeLimited,introduction,rule)


var router = new Router({
  routes: newRoute
    
})

router.beforeEach((to,form, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  devSend("poros_h5_static_page", {
    page_name: to.name,
    path: to.path
  });
  next();
})

export default router